import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import { userAccessTokenSelector } from "../../../security";

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

const workflowController = new WorkFlowController();

export const fetchReadingRequested: Action = createAction(
  ActionTypes.READING_REQUESTED
);
export const fetchReadingReceived: Action = createAction(
  ActionTypes.READING_RECEIVED
);
export const fetchReadingFailed: Action = createAction(
  ActionTypes.READING_FAILED
);
export const setReadingLocation: Action = createAction(
  ActionTypes.SET_READING_LOCATION
);

const fetchAllReadingAPI = (order, options) =>
  workflowController.findByFilter("connectMeters", { order }, options);
export const fetchAllReading = (order = "locationId ASC") => async (
  dispatch,
  getState
) => {
  dispatch(fetchReadingRequested());
  try {
    const btuMeters = await fetchAllReadingAPI(order, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchReadingReceived(btuMeters));
  } catch (err) {
    dispatch(fetchReadingFailed(err));
  }
};

export const approveMetersRequested: Action = createAction(
  ActionTypes.APPROVE_METER_REQUESTED
);
export const approveMetersReceived: Action = createAction(
  ActionTypes.APPROVE_METER_RECEIVED
);
export const approveMetersFailed: Action = createAction(
  ActionTypes.APPROVE_METER_FAILED
);

const approveMetersApi = (data, options) =>
  workflowController.execute("arshon", null, "approveMeters", data, options);
export const approveMeters = data => async (dispatch, getState) => {
  dispatch(approveMetersRequested(data));
  try {
    await approveMetersApi(data, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(approveMetersReceived(data));
  } catch (err) {
    dispatch(approveMetersFailed(err));
    throw err;
  }
};
//
// export const bulkSetCopValuesRequested: Action = createAction(
//   ActionTypes.BULK_SET_COP_VALUES_REQUESTED
// );
// export const bulkSetCopValuesReceived: Action = createAction(
//   ActionTypes.BULK_SET_COP_VALUES_RECEIVED
// );
// export const bulkSetCopValuesFailed: Action = createAction(
//   ActionTypes.BULK_SET_COP_VALUES_FAILED
// );
//
// const bulkSetCopValuesAPI = (data, options) =>
//   workflowController.execute("cop", null, "bulkSet", data, options);
// export const bulkSetCopValues = fileObj => async (dispatch, getState) => {
//   dispatch(bulkSetCopValuesRequested());
//   try {
//     const data = { content: await fileObj.text() };
//     await bulkSetCopValuesAPI(data, { token: userAccessTokenSelector(getState()) });
//     dispatch(bulkSetCopValuesReceived(data));
//   } catch (err) {
//     dispatch(bulkSetCopValuesFailed(err));
//   }
// };



// WEBPACK FOOTER //
// ./src/features/reading/store/readingActions.js